import "core-js/modules/es6.number.is-integer";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.regexp.replace";
import _typeof from "/app/node_modules/@babel/runtime-corejs2/helpers/typeof";
import { testPattern } from 'quasar/src/utils/patterns';
import moment from 'moment';
export var deepClone = function deepClone(objToClone) {
  function clone(obj) {
    var newObj, i;

    if (_typeof(obj) !== 'object') {
      return obj;
    }

    if (!obj) {
      return obj;
    }

    if (Array.isArray(obj)) {
      newObj = [];

      for (i = 0; i < obj.length; i += 1) {
        newObj[i] = clone(obj[i]);
      }

      return newObj;
    }

    newObj = {};

    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        newObj[i] = obj[i] instanceof File ? obj[i] : clone(obj[i]);
      }
    }

    return newObj;
  }

  return clone(objToClone);
};
export var camelToClassName = function camelToClassName(name) {
  if (!name) return 'staff';
  name = name.replace(/([A-Z])/g, '-$1');
  return name.toLowerCase();
};
export var capitalize = function capitalize(str) {
  return str[0].toUpperCase() + str.slice(1);
};
export var stringToColor = function stringToColor(str) {
  var hash = 0;

  for (var _i = 0; _i < str.length; _i++) {
    hash = str.charCodeAt(_i) + ((hash << 11) - hash);
  }

  var color = '#';

  for (var i = 0; i < 3; i++) {
    var value = hash >> i * 8 & 0xFF;
    color += ('00' + value.toString(16)).substr(-2);
  }

  return color;
};
export var prepareStats = function prepareStats() {
  var stats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var result = {};

  for (var key in stats) {
    if (_typeof(stats[key]) === 'object') {
      for (var subKey in stats[key]) {
        var subKeyValue = stats[key][subKey];
        result["".concat(key, "_").concat(subKey)] = roundValue(subKeyValue);
      }
    } else {
      result[key] = roundValue(stats[key]);
    }
  }

  return result;
};
export var roundValue = function roundValue(value) {
  if (!value || isNaN(value)) {
    return 0;
  }

  var fixedValue = value.toFixed(1);
  var isInteger = String(fixedValue).includes('.0');

  if (isInteger) {
    return Math.round(value);
  } else {
    return fixedValue;
  }
};
export var getFullTime = function getFullTime(time) {
  var now = moment().format('YYYY-MM-DD');
  return moment("".concat(now, "T").concat(time)).format('HH:mm:ss');
};
export var checkFuncs = {
  positiveInteger: function positiveInteger(v) {
    return Number(v) > 0 && Number.isInteger(Number(v));
  },
  positiveIntegerAndZero: function positiveIntegerAndZero(v) {
    return v !== '' && Number(v) >= 0 && Number.isInteger(Number(v));
  },
  time: function time(v) {
    return testPattern.time(v);
  },
  nonEmptyString: function nonEmptyString(v) {
    return (v === null || v === void 0 ? void 0 : v.length) > 0;
  }
};